<template>
  <span>
    <div class="btn-group js-new-item">
      <button class="btn btn-secondary" type="button" v-on:click="showNoteForm" v-if="shouldShowNoteForm()">Add Note</button>
      <button class="btn btn-primary" type="button" v-on:click="showTodoForm">Add Todo</button>
      <AttachDocument :project="project" />
    </div>

    <span id='js-todo-form' class='js-new-item d-none'>
      <div class="mt-2 js-task-details-collapse-container">
        <div class="input-group mb-3">
          <input type="text" ref="new_todo" class="form-control" v-model="title" @blur="saveTitle" v-on:keyup.enter="saveTitle" placeholder='New Todo Title'>
          <div class="input-group-append">
            <button class="btn btn-primary" type="button">Save</button>
          </div>
        </div>
      </div>
    </span>

    <span id='js-note-form' class='js-new-item d-none'>
        <div class="mt-2 js-task-details-collapse-container">
          <div class="input-group mb-3">
          <input type="text" ref="new_note" class="form-control" v-model="title" @blur="saveNote" v-on:keyup.enter="saveNote" placeholder='New Note Title'>
            <div class="input-group-append">
              <button class="btn btn-secondary" type="button">Save</button>
            </div>
          </div>
        </div>
    </span>
  </span>
</template>

<script>
  import api from "api";
  import AttachDocument from 'AttachDocument';

  export default {
    data() {
      return {
        title: '',
      };
    },
    components: {
      AttachDocument
    },
    props: ['project', 'selectedTags', 'dueDate', 'tier1', 'inbox'],
    methods: {
      shouldShowNoteForm(){
        if(this.project){
          if(this.project.id){
            return true
          } else {
            return false
          }
        } else if(this.inbox){
          return true
        } else {
          return false
        }
      },
      showTodoForm(){
        $('#js-note-form').removeClass('d-block')
        $('#js-todo-form').addClass('d-block')
        this.$refs.new_todo.focus()
      },
      showNoteForm(){
        $('#js-todo-form').removeClass('d-block')
        $('#js-note-form').addClass('d-block')
        this.$refs.new_note.focus()
      },
      titleContent() {
        return this.title
      },
      saveNote() {
        var newNotes = this.title;
        if(this.project){
          var project_id = this.project.id;
        } else {
          var project_id = null;
        }

        if(newNotes != ''){
          api.createTask({ project_id: project_id, title: newNotes, tags: this.selectedTags, kind: 'comment' }).then(response => {
            this.title = '';
            $('.js-task-details-collapse').collapse('hide')
            $($('.js-task-details-collapse')[0]).collapse('show')
            $('#js-note-form').removeClass('d-block')
          });
        }
      },
      saveTitle: function(event){
        var newTitle = this.title;
        if(this.project){
          var project_id = this.project.id;
        } else {
          var project_id = null;
        }

        if(newTitle != ''){
          if(this.fileCabinet || this.someday || this.new_projects || this.essentials){
            this.dueDate = null;
          } else {
            this.dueDate = new Date();
          }
          api.createTask({ project_id: project_id, title: newTitle, tags: this.selectedTags, due_date: this.dueDate, tier1: this.tier1 }).then(response => {
            this.title = '';
            $('.js-task-details-collapse').collapse('hide')
            $($('.js-task-details-collapse')[0]).collapse('show')
            $('#js-todo-form').removeClass('d-block')
          });
        }
      }
    }
  }
</script>
